import type { PropsWithChildren } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { DailyRanking } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { SelectTrigger } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { FILTER_CHANGED_NOTIFICATION_WIDTH } from "app/components/filters-bar/FiltersBase";
import FilterChangedNotification from "pro-features/components/tooltips/src/filterChangedTooltip/FilterChangedTooltip";
import { EFilterChangedTooltipTypes } from "pro-features/components/tooltips/src/filterChangedTooltip/FilterChangedTooltipTypes";

import { useAlertsParams } from "../../../hooks/useAlertsParams";

const MIN_CONTENT_WIDTH = "226px";

type DurationSelectorButtonProps = PropsWithChildren<{
    isDisabled?: boolean;
}>;

export const DurationSelectorButton = ({ children, ...other }: DurationSelectorButtonProps) => {
    const { translate } = useTranslate();
    const { isDurationChanged } = useAlertsParams();

    return (
        <SelectTrigger
            {...other}
            aria-disabled={other.isDisabled}
        >
            <Flex
                padding={`0 ${isDurationChanged ? "0" : "12px"} 0 16px`}
                alignItems="center"
            >
                <Flex
                    gap="8px"
                    alignItems="center"
                    minWidth={MIN_CONTENT_WIDTH}
                >
                    <DailyRanking
                        size="sm"
                        color={colorsPalettes.carbon[200]}
                    />
                    <Text
                        fontVariant="input2"
                        textAlign="left"
                    >
                        {children}
                    </Text>
                </Flex>
                {isDurationChanged && !other.isDisabled ? (
                    <FilterChangedNotification
                        width={FILTER_CHANGED_NOTIFICATION_WIDTH}
                        tooltipBody={translate("common.filters.duration.tooltip.body")}
                        filterType={EFilterChangedTooltipTypes.DATE_PICKER}
                    />
                ) : null}
            </Flex>
        </SelectTrigger>
    );
};
